import type { AdminShopCategory, AdminShopOptionType } from "../../../api/shop";

export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** The delete guard's tooltip: "Used by 3 products", or null when nothing uses the row. */
export const usedByText = (productCount: number): string | null =>
  productCount > 0 ? `Used by ${plural(productCount, "product", "products")}` : null;

/** The usage shown in a list row. */
export const usedByLabel = (productCount: number): string => usedByText(productCount) ?? "Not used yet";

/** A category with subcategories is deleted only once they are gone, then only when no product uses it. */
export const categoryDeleteBlock = (category: Pick<AdminShopCategory, "productCount" | "subcategories">): string | null =>
  category.subcategories.length > 0
    ? `Has ${plural(category.subcategories.length, "subcategory", "subcategories")}`
    : usedByText(category.productCount);

/** A variant type is deleted only once its values are (each value is guarded on its own). */
export const optionTypeDeleteBlock = (type: Pick<AdminShopOptionType, "values">): string | null =>
  type.values.length > 0 ? `Has ${plural(type.values.length, "value", "values")}` : null;
